import { useMutation } from "@tanstack/react-query"
import axios from "axios"

export const useForgotPasswordMutation = () => {
  return useMutation({
    mutationFn: async (forgotPasswordData: object) => {
      const { data } = await axios.post("/auth/forgotPassword", forgotPasswordData)
      return data.data
    },
  })
}
